export default {
  title: "Collaborators",
  description: "Invite people to help you with your wedding planning",
  count: "{{count}} collaborators",
  invite: "Invite collaborator",
  rolesTitle: "Available roles",
  roles: {
    admin: "Administrator",
    editor: "Editor",
    viewer: "Viewer"
  },
  roleDescriptions: {
    admin: "Can modify everything and manage collaborators",
    editor: "Can modify selected sections",
    viewer: "Can only view selected sections"
  },
  inviteEmail: "Email address",
  placeholder: "Enter the email address of the person to invite",
  role: "Role",
  accessToSections: "Access to sections",
  resourceTypes: {
    tasks: "Tasks",
    guests: "Guests",
    budget: "Budget",
    timeline: "Timeline"
  },
  inviteSuccess: "Invitation sent successfully",
  list: "Collaborator list",
  empty: "No collaborators yet",
  accessTo: "Access to",
  lastActive: "Last active",
  remove: "Remove collaborator",
  modifyAccess: "Modify access",
  updateRoleError: "Error updating role",
  inviteError: "Error sending invitation",
  status: {
    pending: "Pending",
    accepted: "Accepted",
    refused: "Refused",
    expired: "Expired"
  },
  activeLinks: {
    title: "Active Sharing Links",
    description: "Manage permanent links that allow simplified access.",
    copy: "Copy",
    revoke: "Revoke",
    linkCopied: "Link copied!",
    revokeConfirm: "Are you sure you want to revoke this link?",
    revokeSuccess: "Link revoked successfully",
    noActiveLinks: "No active links",
    securityInfo: "These links allow access without an account. Share them with caution."
  }
};
